import {
  LineChartSeries,
  LineChartCategories,
  SelectOptions,
} from './LineChartInterfaces';

export const mockSeries: LineChartSeries[] = [
  {
    name: 'Session Duration',
    data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10, 12, 51],
  },
];
export const mockSeriesPorte: LineChartSeries[] = [
  {
    name: 'Session Duration',
    data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10, 12, 51],
  },
  {
    name: 'Page Views',
    data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35, 112, 51],
  },
  {
    name: 'Total Visits',
    data: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47, 87, 67],
  },
];

export const oneLineMockSeries: LineChartSeries[] = [
  {
    name: 'Total',
    data: [
      450000, 520000, 380000, 240000, 330000, 260000, 210000, 200000, 60000,
      80000, 150000, 100000,
    ],
  },
];

export const mockCategories: LineChartCategories = {
  categories: [
    '02 Dez',
    '03 Dez',
    '04 Dez',
    '05 Dez',
    '06 Dez',
    '07 Dez',
    '08 Dez',
    '09 Dez',
    '10 Dez',
    '11 Dez',
    '12 Dez',
    '13 Dez',
    '14 Dez',
    '15 Dez',
  ],
};

export const mockCategories2: LineChartCategories = {
  categories: [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
  ],
};

export const SelectOptionsMock: SelectOptions[] = [
  {
    value: 'total',
    label: 'Total de acessos',
  },
  {
    value: 'perfil-usuario',
    label: 'Pessoa Física x Pessoa Jurídica',
  },
  {
    value: 'porte',
    label: 'Porte Empresa',
  },
  // {
  //   value: 'tipoAtendimento',
  //   label: 'Tipo de atendimento',
  // },
  // {
  //   value: 'instrumentoAtendimento',
  //   label: 'Instrumento de atendimento',
  // },
];
export const SelectOptionsMockSSE: SelectOptions[] = [
  {
    value: 'total',
    label: 'Total de acessos',
  },
  // {
  //   value: 'perfil-usuario',
  //   label: 'Pessoa Física x Pessoa Jurídica',
  // },
  {
    value: 'porte',
    label: 'Porte Empresa',
  },
];
export const SelectOptionsMockUsuarios: SelectOptions[] = [
  {
    value: 'total',
    label: 'Total de acessos',
  },
];
export const SelectOptionsSASMock: SelectOptions[] = [
  {
    value: 'registros-sas',
    label: 'Total de acessos',
  },
  {
    value: 'perfil-usuario',
    label: 'Pessoa Física x Pessoa Jurídica',
  },
  {
    value: 'atendimentos-porte',
    label: 'Porte de empresa',
  },
];

export const SelectOptionsUsuariosMock: SelectOptions[] = [
  {
    value: 'total',
    label: 'Total de acessos',
  },
  {
    value: 'perfil-usuario',
    label: 'Pessoa Física x Pessoa Jurídica',
  },
  {
    value: 'porte',
    label: 'Porte de empresa',
  },
];
